import * as jQuery from 'jquery';
import './_what-input.min';

const getPlyr = async () => {
  return import('plyr').then(({ default: Plyr }) => {
    return Plyr;
  });
};

const getSwiper = async () => {
  return import('swiper/bundle').then(({ default: Swiper }) => {
    return Swiper;
  });
};

(function($) {

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Variables
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var w = window,
    // d = document,
    $window = $(w),
    $html = $('html'),
    $body = $('body'),
    $header = $('#header'),
    $headerInner = $header.find('.t_header_inner'),
    $main = $('#main'),
    // $adminBar = $('#wpadminbar'),
    // has_adminBar = $body.hasClass('admin-bar'),
    adminBar_h = 0,
    // is_menu_mobile = false,
    $triggerMobile = $('#menuTrigger'),
    sauvScroll = 0,
    headerH,
    // windowH,
    windowW,
    scrollT,
    scrollUp = false;

    $html.addClass('t_is-js-init');
    
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Dimensions
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function update_dimensions() {
        // windowH = window.innerHeight;
        windowW = $window.width();
        headerH = $header.length ? $header.outerHeight() : 0;
        update_adminbar();
        update_scroll();
    }
    update_dimensions();

    function update_scroll() {
        if($window.scrollTop() < scrollT) {
            scrollUp = true;
        } else {
            scrollUp = false;
        }
        scrollT = $window.scrollTop();
    }

    function update_adminbar() {
        adminBar_h = parseInt($html.css("margin-top")) + parseInt($body.css("margin-top"));
    }


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu qui se masque
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function auto_hide_header() {
      // if(is_menu_mobile) {
      //   $html.removeClass('is-nav-hide');
      //   return;
      // }
      if(!scrollUp && scrollT > 2 * headerH) {
        $html.addClass('is-nav-hide');
      } else {
        $html.removeClass('is-nav-hide');
      }
    }


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu sticky
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function sticky_nav_update() {
        // if(is_menu_mobile) {
        //     $html.removeClass('is-sticky-nav');
        //     $header.css('height','auto');
        //     return;
        // }
        if($header.get(0).getBoundingClientRect().top <= adminBar_h) {
            if(!$html.hasClass('is-sticky-nav')) {
                $html.addClass('is-sticky-nav');
            }
            $header.height($headerInner.outerHeight());
        } else {
            if($html.hasClass('is-sticky-nav')) {
                $html.removeClass('is-sticky-nav');
                $header.css('height','auto');
            }
        }
    }

    
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Menu mobile
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var idMenuMobileTimeOut = false;
    $triggerMobile.on('click', function(event) {
        event.preventDefault();
        menu_mobile_toggle();
    });

    function menu_mobile_toggle() {
        if($html.hasClass('t_has-menuMobileOpen')) {
            menu_mobile_close();
        } else {
            menu_mobile_open();
        }
    }

    function menu_mobile_open() {
        if(!$html.hasClass('t_is-scrollBlockedMobile')) {
            sauvScroll = scrollT;
            idMenuMobileTimeOut = w.setTimeout(function() {
                $html.addClass('t_is-scrollBlockedMobile');
            }, 300);
        }
        $html.addClass('t_has-menuMobileOpen');
        $triggerMobile.attr('aria-expanded', 'true');
    }

    function menu_mobile_close() {
        if(idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
        $html.removeClass('t_is-scrollBlockedMobile');
        $triggerMobile.attr('aria-expanded', 'false');
        w.scrollTo(0, sauvScroll);
        w.setTimeout(function() {
            $html.removeClass('t_has-menuMobileOpen');
        }, 50);
    }


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Formulaires
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    function form_init($cont) {
      $cont = $cont && $cont.length ? $cont : $main;
      $cont
        .find('.t_form_field,p.login-username,p.login-password,.pmpro_checkout-field,#other_discount_code_tr,#discount_code_form')
        .find('input:not([type="button"],[type="submit"])')
        .on('blur',function() {
          $(this).closest('p,div,form')[ this.value ? 'addClass' : 'removeClass' ]('t_is-filled');
        })
        .on('focusin', function() {
          $(this).closest('p,div,form').addClass('t_is-active');
        })
        .on('focusout', function() {
          $(this).closest('p,div,form').removeClass('t_is-active');
        })
        .trigger('blur');
      $cont.find('select').on('change', function(event) {
        $(this).closest('p,div')[ this.value ? 'addClass' : 'removeClass' ]('t_is-filled');
        }).trigger('change');
      $cont.find('.t_form_check,p.login-remember')
        .find('input:checkbox')
        .on('change',function() {
          $(this).closest('p,div')[ $(this).is(':checked') ? 'addClass' : 'removeClass' ]('t_is-checked');
        })
        .trigger('change');
    }
    form_init();


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Lecteurs vidéos Plyr
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    const players_init = async () => {
      const Plyr = await getPlyr();
      $( '.wp-block-embed.is-type-video .wp-block-embed__wrapper iframe' ).on( 'load', function() {
        var $iframe  = $(this),
            $wrapper = $iframe.parent( '.wp-block-embed__wrapper' );

        new Plyr( $wrapper.get(0), {
          controls: [
            'play',
            'progress',
            'current-time',
            'mute',
            'volume',
            'fullscreen',
          ],
        });
      });
    };
    players_init();

    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //Sliders
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    const sliders_testimonials = async(idx, el) => {
      var $slider = $(el);
      $slider.addClass('swiper');
      $slider.children().wrapAll('<div class="swiper-wrapper">');
      $slider.find('blockquote').addClass('swiper-slide');
      $slider.append( '<div class="swiper-pagination" />' );
      const Swiper = await getSwiper();
      new Swiper(el, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 50,
        pagination: {
          el: $slider.find('.swiper-pagination').get(0),
          clickable: true,
          type: 'bullets',
        }
      });
    }

    const sliders_posts = async(idx, el) => {
      var $slider = $(el);
      $slider.addClass('swiper');
      $slider.children().wrapAll('<div class="swiper-wrapper">');
      $slider.find('article').addClass('swiper-slide');
      const Swiper = await getSwiper();
      new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: "6%",
        freeMode: true,
        breakpoints: {
          // when window width is >= 960
          960: {
            spaceBetween: 60,
          },
        },
      });
    }

    const sliders_homes = async(idx, el) => {
      var $slider = $(el);
      var $parent = $slider.closest( '.t_slider' );
      $slider.addClass('swiper');
      $slider.children().wrapAll('<div class="swiper-wrapper">');
      $slider.find('figure').addClass('swiper-slide');
      $slider.append( '<div class="swiper-pagination" />' );
      const Swiper = await getSwiper();
      var swiper_homes = new Swiper(el, {
        speed: 500,
        slidesPerView: 1,
        width: windowW * 2,
        spaceBetween: 0,
        pagination: {
          el: $slider.find('.swiper-pagination').get(0),
          clickable: true,
          type: 'bullets',
        },
        breakpoints: {
          // when window width is >= 960
          960: {
            width: windowW,
          },
        },
        on: {
          slideChange: function(swiper) {
            var current  = swiper.activeIndex;
            var max      = swiper.slides.length;
            var position = current * 100 / max;
            $parent.css( 'background-position-x', position + '%' );
          }
        }
      });

      $(window).resize(function(){
        swiper_homes.params.width = windowW * 2;
      })
    }

    const sliders_logos = async(idx, el) => {
      // largeur slider :
      // — au-dessus de 960px  :  88vw - 120px
      // — en-dessous de 960px : 100vw - 120px
      // largeur logo :
      // — au-dessus de 960px  : 170px
      // — en-dessous de 960px : 100px
      var $slider = $(el);
      $slider.children().wrapAll('<div class="swiper"><div class="swiper-wrapper">');
      $slider.find('figure').addClass('swiper-slide');
      $slider.append( '<div class="t_logos_prev"></div>' );
      $slider.append( '<div class="t_logos_next"></div>' );
      const Swiper = await getSwiper();
      new Swiper($slider.find('.swiper').get(0), {
        speed: 500,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: $slider.find('.t_logos_next').get(0),
          prevEl: $slider.find('.t_logos_prev').get(0),
        },
        breakpoints: {
           420: { slidesPerView: 3, slidesPerGroup: 3 },
           520: { slidesPerView: 4, slidesPerGroup: 4 },
           620: { slidesPerView: 5, slidesPerGroup: 5 },
           720: { slidesPerView: 6, slidesPerGroup: 6 },
           820: { slidesPerView: 7, slidesPerGroup: 7 },
           920: { slidesPerView: 8, slidesPerGroup: 8 },
           960: { slidesPerView: 4, slidesPerGroup: 4 },
          1085: { slidesPerView: 5, slidesPerGroup: 5 },
          1280: { slidesPerView: 6, slidesPerGroup: 6 },
          1472: { slidesPerView: 7, slidesPerGroup: 7 },
          1665: { slidesPerView: 8, slidesPerGroup: 8 },
        },
      });
    }

    function sliders_init() {
      var $testimonials = $body.find(".t_testimonial:not(.slider-enabled)");
      $testimonials.each(function (idx, el) {
        sliders_testimonials(idx, el);
      });
      var $posts = $body.find(".t_posts:not(.slider-enabled)");
      $posts.each(function (idx, el) {
        sliders_posts(idx, el);
      });
      var $homeSliders = $body.find(".t_slider_slides:not(.slider-enabled)");
      $homeSliders.each(function (idx, el) {
        sliders_homes(idx, el);
      });
      var $logosSliders = $body.find(".t_logos:not(.slider-enabled)");
      $logosSliders.each(function (idx, el) {
        sliders_logos(idx, el);
      });
    }
    sliders_init();


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //On resize
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $window.on('resize', function() {
        update_dimensions();
        $window.trigger('scroll');
    });


    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //On scroll
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var ticking = false;
    $window.on('scroll', function() {
        update_scroll();
        requestTick();
    });

    function requestTick() {
        if (!ticking) {
        ticking = true;
        w.requestAnimationFrame(trigger_scroll);
        }
    }

    function trigger_scroll() {
        ticking = false;
        sticky_nav_update();
        auto_hide_header();
        // inview_update();
    }

    $window.trigger('resize');

})(jQuery);